/* libs */
import React from "react";
import PropTypes from "prop-types";

const Header = props => {
	return (
		<div className="title wrapper">
			<h3 className="page-title">{props.title}</h3>
		</div>
	);
};

Header.propTypes = {
	title: PropTypes.string,
	itemName: PropTypes.string,
	createNew: PropTypes.func,
};

export default Header;
